
import Vue from 'vue'
import Component from 'vue-class-component'

import { State, Mutation } from 'vuex-class'

import BlueButton from '../components/Atomic/BlueButton.vue'
import HelpTooltip from '../components/Atomic/HelpTooltip.vue'
import ChangeEmail from '../components/ChangeEmail.vue'
import Permissions from '@/models/constants/Permissions'
import CardTitle from '../components/Atomic/CardTitle.vue'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

import UserService from '@/services/UserService'

@Component({
  components: {
    BlueButton,
    ChangeEmail,
    CardTitle,
    HelpTooltip,
    ToolTipButton,
  },
})
export default class Home extends Vue {
  @State('user') public user!: any
  @Mutation private setUser: any
  private changeEmailDialog: boolean = false

  private async saveMailChange(chosenEmail: string, username: string) {
    await UserService.updateOwnMask(chosenEmail, username)
    const updatedStoreUser = this.user
    updatedStoreUser.mail = chosenEmail + '@edu-vd.ch'
    this.setUser(updatedStoreUser)
  }

  private get hasAccessToChangeOwnEmail(): boolean {
    const allowed = [Permissions.ChangeOwnEmail]
    if (
      (this.user.permissions as []).some((permission) =>
        allowed.includes(permission),
      )
    ) {
      return true
    }
    return false
  }

  private get hasAccessToChangeOwnPassword(): boolean {
    const allowed = [Permissions.ChangeOwnPassword]
    if (
      (this.user.permissions as []).some((permission) =>
        allowed.includes(permission),
      )
    ) {
      return true
    }
    return false
  }

  private changePassword() {
    this.$router.push('/change-password')
  }

  private closeMailChangeDialog() {
    this.changeEmailDialog = false
  }
}
